import { createFileRoute } from "@tanstack/react-router";
import AdminCategoryDetailPage from "@/admin/pages/category-detail";

export const Route = createFileRoute("/admin/categories/$id")({
  component: AdminCategoryDetailPage,
});
